import { Card, Skeleton, Space } from "antd";

const FilterSkeleton = () => {
  return (
    <div className="filterSkeleton d-xl-block d-none col-xl-4 col-xxl-3"> {/* Adjust width as per layout */ }
      <Card bordered={false} className="card bg-transparent">
        {/* Sort By Skeleton */}
        {/* <div className="card-header border-bottom bg-transparent px-0 pt-0">
          <Skeleton.Input style={{ width: 180, height: 32 }} active size="default" />
        </div> */}

        {/* Filters Section */}
        <Card className="card-body p-0">
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            {/* Filter Categories */}
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index}>
                <Skeleton.Input style={{ width: 150, height: 20 }} active size="small" />
                <div className="row g-1 mt-2">
                  {Array.from({ length: 2 }).map((_, colIndex) => (
                    <div className="col-12 px-0" key={colIndex}> {/* Full width list items */}
                      <ul className="list-group list-group-borderless">
                        {Array.from({ length: 3 }).map((_, itemIndex) => (
                          <li key={itemIndex} className="list-group-item pb-0 d-flex align-items-center">
                            <Skeleton.Avatar shape="circle" size="small" />
                            <Skeleton.Input style={{ width: "100%", marginLeft: 8 }} active size="small" />
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </Space>
          <div className="mt-5">
          <Skeleton.Input style={{ width: 120 }} active size="small" />
          <div className="d-flex mt-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton.Button key={i} active size="small" shape="default" style={{ width: 50, marginRight: 10 }} />
            ))}
          </div>
        </div>
        </Card>
      </Card>
    </div>
  );
};

export default FilterSkeleton;
